module.exports = __webpack_public_path__ + "./assets/img_hushan_grey@2x__6f2d64bd15595c63e00263f6c224a64a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/thumbnail/img_hushan_grey@2x.jpg
// module id = 641
// module chunks = 12